import { FigureAxisSettings, isFigureAxisSettings } from "./FigureAxisSettings";
import { FigureLegendSettings, isFigureLegendSettings } from "./FigureLegendSettings";
import {
  FigureRegressionLineSettings,
  isFigureRegressionLineSettings,
} from "./FigureRegressionLineSettings";
import { FigureTypeSettings, isFigureTypeSettings } from "./FigureTypeSettings";
import { FigureVarSettings, isFigureVarSettings } from "./FigureVarSettings";

export interface FigureSettings {
  figureTypeSettings: FigureTypeSettings[];
  figureProperties: FigureVarSettings[];
  figureAxisSettings: FigureAxisSettings[];
  figureLegendSettings: FigureLegendSettings[];
  figureReferenceLinesSettings: FigureVarSettings[];
  figureRegressionLineSettings: FigureRegressionLineSettings[];
}

/**
 * Type guard to check if an object is a FigureSettings
 *
 * @param obj - The object to check
 * @returns - true if the object is a FigureSettings
 */
export const isFigureSettings = (obj: unknown): obj is FigureSettings => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureSettings;
  if (!Array.isArray(chkObj.figureTypeSettings)) {
    return false;
  }
  if (chkObj.figureTypeSettings.some((option) => !isFigureTypeSettings(option))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureProperties)) {
    return false;
  }
  if (chkObj.figureProperties.some((varSetting) => !isFigureVarSettings(varSetting))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureAxisSettings)) {
    return false;
  }
  if (chkObj.figureAxisSettings.some((axisType) => !isFigureAxisSettings(axisType))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureLegendSettings)) {
    return false;
  }
  if (chkObj.figureLegendSettings.some((legendType) => !isFigureLegendSettings(legendType))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureRegressionLineSettings)) {
    return false;
  }
  if (
    chkObj.figureRegressionLineSettings.some(
      (lineOption) => !isFigureRegressionLineSettings(lineOption),
    )
  ) {
    return false;
  }
  if (!Array.isArray(chkObj.figureReferenceLinesSettings)) {
    return false;
  }
  if (chkObj.figureReferenceLinesSettings.some((lineOption) => !isFigureVarSettings(lineOption))) {
    return false;
  }
  // Everything is good
  return true;
};
